(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["factory-2024-poinner"] && !Shopify.designMode) return;
  try {
    
  function animated() {
    let counters = document.querySelectorAll('.num');  //获取到三个counter盒子

    counters.forEach(item => {
      item.innerText = '1';  //记录分数变化的变量，初始值为0

      const updateData = () => {
        const data = +item.getAttribute('data-end');  //获取到元素中绑定的数据
        const tmp = +item.innerText; //临时变量保存变化一次的数据量
        var changeData = 0;
        changeData = data / 35;  //设置默认改变的速率
        if (tmp < data) {  //如果临时变量的值小于最终数据的值，那么就给元素进行数据相加
          item.innerText = `${Math.ceil(tmp + changeData)}`;  //值数相加，然后进行取整
          setTimeout(updateData, 5);  //定时器传入回调函数目的在于动态变化
        } else {
          item.innerText = data.toLocaleString().replace(/,/g, ' ') + '+';  //不满足条件后，证明得到了最终数据，直接渲染
        }
      }
      updateData();  //调用函数，启动函数
    })
  }

  var targetElement = document.querySelector('.factory-2024-poinner');
  var windowHeight = window.innerHeight;
  var animationTriggered = false;

  function executeAnimation() {
    if (animationTriggered) return; // 如果动画已触发，则直接返回
    animated();
    animationTriggered = true; // 设置动画已触发的标志
  }

  function checkVisibility() {
    var elementTop = targetElement.getBoundingClientRect().top;
    var elementBottom = targetElement.getBoundingClientRect().bottom;

    if (elementTop < windowHeight && elementBottom >= 0) {
      executeAnimation();
    }
  }

  window.addEventListener('scroll', checkVisibility);
  window.addEventListener('resize', () => {
    windowHeight = window.innerHeight;
    
    checkVisibility();
  });
  checkVisibility(); // 初始检查

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-slideshow"] && !Shopify.designMode) return;
  try {
    
class SliderShow extends HTMLElement {
constructor() {
super();
this.init = this.init.bind(this);
this.config = JSON.parse(this.querySelector('[data-config]').dataset.config);

this.init();
window.addEventListener('resize', Shopify.debounce(this.init, 1000));
}
init() {
const {offsetWidth} = document.documentElement;
const {ratioMobile, ratioPc, ratioTable} = this.config;
if (offsetWidth <= 760) {
UIkit.slideshow(this, Object.assign(this.config, {ratio: ratioMobile}));
} else if (offsetWidth <= 1440) {
UIkit.slideshow(this, Object.assign(this.config, {ratio: ratioTable}));
} else {
UIkit.slideshow(this, Object.assign(this.config, {ratio: ratioPc}));
}
}
}
customElements.define('slider-show', SliderShow)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
class CartNote extends HTMLElement {
constructor() {
super();

this.addEventListener('change', debounce((event) => {
const body = JSON.stringify({ note: event.target.value });
fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
}, 300))
}
}
customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
    // 根据搜索类型给结果页赋标题
  var contTitleDocument = document.querySelector('.cont-title')
  var productSearchButtonDocument = document.querySelector('#product-search-button')
  var articleSearchButtonDocument = document.querySelector('#article-search-button')
  var type = document.querySelector('.search-type').value;
  if (type == 'product') {
    productSearchButtonDocument.classList.add('active');
    articleSearchButtonDocument.classList.remove('active');
    if (contTitleDocument) {
      contTitleDocument.innerHTML = 'All Products'
    }
  } else if (type == 'article') {
    productSearchButtonDocument.classList.remove('active');
    articleSearchButtonDocument.classList.add('active');
    if (contTitleDocument) {
      contTitleDocument.innerHTML = 'Blog'
    }
  } else if (type == 'page') {
    if (contTitleDocument) {
      contTitleDocument.innerHTML = 'Page'
    }
  } else {
    if (contTitleDocument) {
      contTitleDocument.innerHTML = 'Results'
    }
  }
const itemBtn = document.querySelectorAll('[data-grid-item]');
let nowProductUrl = '';
if(itemBtn.length > 0) {
itemBtn.forEach(element => {
element.addEventListener('click', async event => {
event.preventDefault();
const { target } = event;
const url = `${target.href}`;
if(url === nowProductUrl) {
UIkit.modal('#js-product-modal').show();
return;
} else {
document.querySelector('[data-quick-container]').innerHTML = `<div class="uk-position-cover uk-flex uk-flex-center uk-flex-middle">
  <i uk-spinner="ratio: 1.3;"></i>
</div>`;
}
UIkit.modal('#js-product-modal').show();

nowProductUrl = url;
const source = await fetch(url)
.then((response) => response.text())
.then((responseText) => {
const html = new DOMParser().parseFromString(responseText, 'text/html')
return html.querySelector('[data-main-product]')
});
if (source) {
document.querySelector('[data-quick-container]').innerHTML = source.innerHTML;
Shopify.PaymentButton.init();
}
})
})
}
   document.getElementById('product-search-button').addEventListener('click', function () {
    this.style.textDecoration = 'underline';
    document.getElementById('article-search-button').style.textDecoration = 'none';
  });

  document.getElementById('article-search-button').addEventListener('click', function () {
    this.style.textDecoration = 'underline';
    document.getElementById('product-search-button').style.textDecoration = 'none';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-user-guides"]) return;
  try {
    
class videoComponent extends HTMLElement{
constructor() {
super();
this.isShowMore = false;
this.showString = {
show: "Show More",
close: "Close"
}
this.playsBtns = this.querySelectorAll('[data-code]');
this.init();
}
init() {
if(this.playsBtns.length >= 1) {
this.playsBtns.forEach((btn) => {
btn.addEventListener('click', (e) => {
e.target.blur();
const videoUrl = e.target.dataset.code;
const videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="//www.youtube-nocookie.com/embed/${videoUrl}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
UIkit.modal.dialog(`<div>${videoElement}<style>.uk-modal-dialog {width: 1200px;}</style></div>`);
});
});
}
if(this.playsBtns.length > 4) {
this.querySelector('[data-more]').addEventListener('click', (e) => {
this.isShowMore = !this.isShowMore;
e.target.innerHTML = this.isShowMore ? this.showString.close : this.showString.show;
this.classList.toggle('show', this.isShowMore);
});
}
}
}
customElements.define('video-component', videoComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tech-specs"] && !Shopify.designMode) return;
  try {
    
  const nullState = `<div class="uk-container uk-position-relative uk-section-small uk-padding-remove-top"><span class="uk-h4">Null</span></div>`;
  class tabs {
    constructor(container) {
      this.state = {
        cacheData: {},
      };
      this.selectors = {
        tabButtons: container.querySelectorAll('[data-tech-handle]'),
        tabContent: container.querySelector('[data-tech-content]'),
      };
      if (this.selectors.tabButtons.length) {
        this.init();
      }
    }
    init() {
      const { state, selectors } = this;
      const { cacheData } = state;
      const { tabButtons, tabContent } = selectors;
      const key = `TAB0`;
      const fistTabHandle = tabButtons[0].dataset.techHandle;
      if (location.href.indexOf(fistTabHandle) !== -1) {
        cacheData[key] = tabContent.innerHTML;
      } else {
        this.updateSections(0, tabButtons[0].dataset.techHandle);
      }

      tabButtons.forEach((element, index) => {
        element.addEventListener(
          'click',
          (event) => {
            event.target
              .closest('ul')
              .querySelectorAll('li')
              .forEach((e) => e.classList.remove('tm-active'));
            event.target.closest('li').classList.add('tm-active');
            this.updateSections(index, event.target.dataset.techHandle);
          },
          false
        );
      });
    }
    async updateSections(index, url) {
      const key = `TAB${index}`;
      const { state, selectors } = this;
      const { cacheData } = state;
      const { tabContent } = selectors;
      if (!cacheData[key]) {
        const data = await this.requestData(url);
        tabContent.innerHTML = cacheData[key] = data ? data : nullState;
      } else {
        tabContent.innerHTML = cacheData[key];
      }
    }
    async requestData(url) {
      return await fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          return html.querySelector('[data-tech-content]').innerHTML;
        });
    }
  }
  new tabs(document.querySelector('[data-section-type="product-tech-specs"]'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-videos"] && !Shopify.designMode) return;
  try {
    
class videoComponent extends HTMLElement{
constructor() {
super();
this.isShowMore = false;
this.showString = {
show: "See More",
close: "Close"
}
this.heroBtn = this.querySelector('[data-hero]');
this.playsBtns = this.querySelectorAll('[data-code]');

this.init();
}

play (code) {
if(!code) {
return;
}
const videoUrl = `//www.youtube-nocookie.com/embed/${code}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1`;
const videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="${videoUrl}" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
UIkit.modal.dialog(`<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1200px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`);
}

init() {
const playLength = this.playsBtns.length;
if(this.heroBtn) {
this.heroBtn.addEventListener('click', (e) => {
e.target.blur();
this.play(e.target.dataset.hero);
});
}

if(playLength >= 1) {
this.playsBtns.forEach((btn) => {
btn.addEventListener('click', (e) => {
e.target.blur();
this.play(e.target.dataset.code);
});
});
}

if(playLength > 3) {
this.querySelector('[data-more]').addEventListener('click', (e) => {
this.isShowMore = !this.isShowMore;
e.target.innerHTML = this.isShowMore ? this.showString.close : this.showString.show;
this.classList.toggle('show', this.isShowMore);
});
}
}
}
customElements.define('video-component', videoComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-list"] && !Shopify.designMode) return;
  try {
    
let isShow = false;
const showString = {
show: "View More",
close: "Close"
}
document.querySelector('[data-more]')?.addEventListener('click', (e) => {
isShow = !isShow;
e.target.innerHTML = isShow ? showString.close : showString.show;
document.querySelector('[data-list-container]').classList.toggle('show', isShow);
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["public-collection"] && !Shopify.designMode) return;
  try {
    
const itemBtn = document.querySelectorAll('[data-grid-item]');
let nowProductUrl = '';
if (itemBtn.length > 0) {
  itemBtn.forEach(element => {
    element.addEventListener('click', async event => {
      event.preventDefault();
      const { target } = event;
      const url = `${target.href}`;
      UIkit.modal('#js-product-modal').show();
      if (url === nowProductUrl) return;

      document.querySelector('[data-quick-container]').innerHTML = `<div class="uk-position-cover uk-flex uk-flex-center uk-flex-middle"><i uk-spinner="ratio: 1.3;"></i></div>`;
      nowProductUrl = url;
      const source = await fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          return html.querySelector('[data-main-product]')
        });

      if (source) {
        document.querySelector('[data-quick-container]').innerHTML = source.innerHTML;
        Shopify.PaymentButton.init();
        try {
          affirm.ui.refresh()
        } catch (e) {
          console.error(e)
        }
      }
    })
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-new"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(container) {
      this.container = container;
      this.firstType = this.container.querySelector('[uk-slideshow].js-enable-top')
        ? this.container.querySelector('[uk-slideshow].js-enable-top li').classList.contains('uk-light')
        : false;
      this.initSlideshow(this.firstType);
      this.init();
    }

    initSlideshow(flag) {
      document.querySelector('.tm-header').classList.toggle('uk-light', flag);
    }

    init() {
      this.container.querySelector('[uk-slideshow].js-enable-top')?.addEventListener('beforeitemshow', (e) => {
        const is_light = e.target.classList.contains('uk-light');
        this.initSlideshow(is_light);
      });
    }
  }
  if (document.querySelector('[data-section-type="slideshow"]')) {
    new Slideshow(document.querySelector('[data-section-type="slideshow"]'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(container) {
      this.container = container;
      this.firstType = this.container.querySelector('[uk-slideshow].js-enable-top li').classList.contains('uk-light');
      this.initSlideshow(this.firstType);
      this.init();
    }

    initSlideshow(flag) {
      document.querySelector('.tm-header').classList.toggle('uk-light', flag);
    }

    init() {
      this.container.querySelector('[uk-slideshow].js-enable-top')?.addEventListener('beforeitemshow', (e) => {
        const is_light = e.target.classList.contains('uk-light');
        this.initSlideshow(is_light);
      });
    }
  }
  new Slideshow(document.querySelector('[data-section-type="slideshow"]'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speed-dial"]) return;
  try {
    
  class SpeedDial extends HTMLElement {
    constructor() {
      super()

      // 元素的初始化逻辑
      this.speedDial = null
      this.mainButton = null
      this.subButtons = null
    }

    connectedCallback() {
      // 在元素插入到文档中的时候, 初始化引用并绑定事件
      this.speedDial = this
      this.mainButton = this.speedDial.querySelector('.main-button')
      this.subButtons = this.speedDial.querySelectorAll('.sub-button')
      this.mainButton.addEventListener('click', this.toggleSubButtons.bind(this))
    }

    disconnectedCallback() {
      // 在元素从文档中移除时解绑事件
      if (this.mainButton) {
        this.mainButton.removeEventListener('click', this.toggleSubButtons.bind(this))
      }
      this.removeGlobalClickListener()
    }

    toggleSubButtons(event) {
      if (this.speedDial) {
        this.speedDial.classList.toggle('show')
        if (this.speedDial.classList.contains('show')) {
          this.addGlobalClickListener()
          this.calculateSubButtonPositions()
        } else {
          this.resetSubButtonPositions()
          this.removeGlobalClickListener()
        }
      }
      event.stopPropagation() // 防止事件冒泡到document
    }

    calculateSubButtonPositions() {
      const distance = this.getDistance()
      this.subButtons.forEach((button, index) => {
        const y = -(distance * (index + 1)) // Calculate the upward position
        // Set the position of the sub-buttons
        button.style.transform = `translateY(${y}px)`
      })
    }

    resetSubButtonPositions() {
      this.subButtons.forEach((button) => {
        // Reset the position back to initial
        button.style.transform = 'translateY(0)'
      })
    }

    addGlobalClickListener() {
      document.addEventListener('click', this.handleClickOutside.bind(this))
    }

    removeGlobalClickListener() {
      document.removeEventListener('click', this.handleClickOutside.bind(this))
    }

    handleClickOutside(event) {
      if (this.speedDial && !this.speedDial.contains(event.target)) {
        this.resetSubButtonPositions() // Important: Reset positions before hiding
        this.speedDial.classList.remove('show')
        this.removeGlobalClickListener()
      }
    }

    getDistance() {
      return window.matchMedia('(max-width: 768px)').matches ? 50 : 60
    }
  }

  customElements.define('speed-dial', SpeedDial)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-faqs"] && !Shopify.designMode) return;
  try {
    
let flag = false;
const showString = {
show: "Show More",
close: "Close"
}
document.querySelectorAll('[data-group]').forEach(element => {
const oBtn = element.querySelector('button');
if (oBtn) {
oBtn.addEventListener('click', (e) => {
flag = !flag;
e.target.innerHTML = flag ? showString.close : showString.show;
element.querySelector('[uk-accordion]').classList.toggle('open', flag)
});
}
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-list"] && !Shopify.designMode) return;
  try {
    
class videoComponent extends HTMLElement{
    constructor() {
        super();
        this.isShowMore = false;
        this.showString = {
        show: "See More",
        close: "Close"
    }
    this.heroBtn = this.querySelector('[data-hero]');
    this.playsBtns = this.querySelectorAll('[data-code]');

    this.init();
}

play (code) {
  console.log(code);
    if(!code) {return;}
    const videoUrl = `//www.youtube-nocookie.com/embed/${code}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1`;
    const videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="${videoUrl}" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
    UIkit.modal.dialog(`<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1200px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`);
}

init() {
    const playLength = this.playsBtns.length;
    if(this.heroBtn) {
        this.heroBtn.addEventListener('click', (e) => {
            e.target.blur();
            this.play(e.target.dataset.hero);
        });
    }

    if(playLength >= 1) {
        this.playsBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.target.blur();
                this.play(e.target.dataset.code);
            });
        });
    }

    if(playLength > 3) {
        this.querySelector('[data-more]').addEventListener('click', (e) => {
            this.isShowMore = !this.isShowMore;
                e.target.innerHTML = this.isShowMore ? this.showString.close : this.showString.show;
                this.classList.toggle('show', this.isShowMore);
            });
        }
    }
}
customElements.define('video-component', videoComponent);

  } catch(e) { console.error(e); }
})();
})();
